import React from 'react'
import Helmet from 'react-helmet'


const SEO = (props) => {

  // console.log('props',props.data);


  const friendlyURL = (path) => {
    const domain = `https://www.dhruvkumarjha.com`;
    if ( path[0] === '/' ) {
      return `${domain}${path}`;
    } else {
      return `${domain}/${path}`;
    }
  }


  if ( props.data.type === 'page' ) {
    return (
      <Helmet
        title={ props.data.title }
        meta={[
          { name: 'description', content: props.data.description },
          { name: 'keywords', content: props.data.keywords },
        ]}
      />
    );
  }


  if ( props.data.type === 'post' || props.data.type === 'series' ) {
    let KEYWORDS = '';
    let TTILE = props.data.title;

    if ( props.data.tags && props.data.tags.length > 0 ) { KEYWORDS = props.data.tags.join(', '); }
    if ( props.data.html_title ) { TTILE = props.data.html_title; }


    return (
      <Helmet>
        <title>{ TTILE }</title>
        <meta name="description" content={ props.data.description } />
        <meta name="keywords" content={ KEYWORDS } />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={ friendlyURL(props.data.path) } />
        <meta name="twitter:site" content="@dhruv_kumar_jha" />
        <meta name="twitter:creator" content="@dhruv_kumar_jha" />
        <meta name="twitter:title" content={ TTILE } />
        <meta name="twitter:description" content={ props.data.description } />
        <meta name="twitter:image" content={ props.data.image } />

        <meta property="og:title" content={ TTILE } />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={ friendlyURL(props.data.path) } />
        <meta property="og:image" content={ props.data.image } />
        <meta property="og:description" content={ props.data.description } />
        <meta property="og:site_name" content="Dhruv Kumar Jha" />

        <script type="application/ld+json">
        {`
          {
            "@context": "http://schema.org",
            "@type": "TechArticle",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "https://www.dhruvkumarjha.com"
            },
            "headline": "${ TTILE }",
            "image": {
              "@type": "ImageObject",
              "url": "${ props.data.image }"
            },
            "author": {
              "@type": "Person",
              "name": "Dhruv Kumar Jha"
            },
            "editor": "Dhruv Kumar Jha",
            "genre": "",
            "keywords": "${ KEYWORDS }",
            "publisher": {
              "@type": "Person",
              "name": "Dhruv Kumar Jha"
            },
            "url": "${ friendlyURL(props.data.path) }",
            "datePublished": "${ props.data.date }",
            "dateCreated": "${ props.data.date }",
            "dateModified": "${ props.data.updated ? props.data.updated : props.data.date }",
            "description": "${ props.data.description }"
          }
        `}
        </script>

      </Helmet>
    );
  }




  return (
    <Helmet
      title={ 'Dhruv Kumar Jha' }
    />
  );

}


export default SEO


/*
            "image": {
              "@type": "ImageObject",
              "url": "${ props.data.image }",
              "height": ${ article.image.height || 800 },
              "width": ${ article.image.width || 800 }
            },
          { name: 'viewport', content: 'width=device-width, initial-scale=1, shrink-to-fit=yes' },

*/



// WEBPACK FOOTER //
// ./src/global/components/SEO.js